import { OrderBy } from '@/types/shared/filters'
import { DEFAULT_PAGE_SIZES } from '@/types/shared/pagination'
import type { IRepairRequestFilters } from '@/types/rc/filters'
import { defineStore } from 'pinia'
import { stringify } from 'qs'
import { ref } from 'vue'

/**
 * Repair request filters Pinia store.
 */
export const useRepairRequestFilterStore = defineStore('repair-request-filters', () => {
  // By default, order by "updated_at" in "DESC" order.
  const defaultFilters = <IRepairRequestFilters>{
    customer_id: undefined,
    number: undefined,
    page: 1,
    per_page: DEFAULT_PAGE_SIZES[0],
    order_by: 'updated_at',
    order_by_order: OrderBy.DESC,
    status: undefined,
  }

  const filters = ref<IRepairRequestFilters>({ ...defaultFilters })

  /**
   * Resets filters to default.
   */
  const $reset = () => {
    filters.value = { ...defaultFilters }
  }

  /**
   * Set customer ID filter.
   * Todo: replace me with a call to the customer store (not yet implemented).
   *
   * @param customerId a customer ID.
   */
  const setCustomer = (customerId: string) => {
    filters.value.customer_id = customerId
  }

  /**
   * Toggle sort order between "ASC" and "DESC".
   */
  const toggleSortOrder = () => {
    filters.value.order_by_order = filters.value.order_by_order === OrderBy.DESC ? OrderBy.ASC : OrderBy.DESC
  }

  /**
   * Creates a query string based on current filters.
   *
   * @returns {string} URL query string with filter key-values.
   */
  const getQueryString = (): string => {
    return stringify(filters.value)
  }

  return {
    filters,
    $reset,
    setCustomer,
    toggleSortOrder,
    getQueryString,
  }
})
